module.exports = __webpack_public_path__ + "static/media/3.8a93eaf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/3.jpg
// module id = 1637
// module chunks = 0